import { ProgressReportPreviewInterface, Summary } from '@/src/models/IProgress';
import { FacilityInterface } from '@/src/models/IShowUser';
import { Button, Card, Col, DatePicker, Flex, Form, Input, InputNumber, message, notification, Radio, Row, Select, Table, Tag } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, Rectangle, ResponsiveContainer, Tooltip, TooltipProps, XAxis, YAxis } from 'recharts';
import { UndoOutlined,SearchOutlined } from '@ant-design/icons';

export function StaffReportList(){
    const navigate = useNavigate();
    const [showstatus,setshowstatus] = useState('รายงานความก้าวหน้า');
    const [ProgressReportList,setProgresslist] = useState<ProgressReportPreviewInterface[]>([])
    const [CompleteReportList,setCompleteReportList]  = useState<ProgressReportPreviewInterface[]>([])
    const [ShownCompleteReportList,setShownCompleteReportList]  = useState<ProgressReportPreviewInterface[]>([])


    const [SearchForm] = Form.useForm();
    const [summary_data,setSummarydata]=useState<Summary[]>([]);
    const [fac_summary_data,setFacSummarydata]=useState<Summary[]>([]);
    const [fac_budget_data,setFacBudgetData]=useState<Summary[]>([]);

    const [YearType,setYearType] = useState('ปีการศึกษา')
    const [YearQuery,setYearQuery] = useState()

    const [FacYearType,setFacYearType] = useState('ปีการศึกษา')
    const [FacYearQuery,setFacYearQuery] = useState()


    const [Fac,setFac] = useState<FacilityInterface[]>([]);

    const months = [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ];
  
    const CustomTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
        if (active && payload && payload.length > 0) {
        return (
            <div
            className="custom-tooltip"
            style={{
                backgroundColor: '#fff',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
            }}
            >
            <p className="label" style={{ fontWeight: 'bold', marginBottom: '5px' }}>{`หมวดหมู่: ${label}`}</p>
            {payload[0] && (
                <p style={{ color: '#8884d8' }}>{`ยอดทุนที่ขอ: ${Number(payload[0].value).toLocaleString()} บาท`}</p>
            )}
            {payload[1] && (
                <p style={{ color: '#82ca9d' }}>{`ยอดทุนที่ใช้ไป: ${Number(payload[1].value).toLocaleString()} บาท`}</p>
            )}
            </div>
        );
        }
    
        return null;
    };

    
    const filterByMonth = (data: any[], month: number) => {
        return data.filter((item) => {
        const itemMonth = moment(item.SentBy).month() ;
        return itemMonth === month;
        });
    };

    const getData = async() =>{
        axios.get(`${process.env.REACT_APP_BASE}/GetProgressList`).then(async response=>{
            if(response.status==200){
                console.log(response.data)
                setProgresslist(response.data.filter((item: { IsCompletion: string; })=>item.IsCompletion=="FALSE"))
                setCompleteReportList(response.data.filter((item: { IsCompletion: string; })=>item.IsCompletion=="TRUE"))
                setShownCompleteReportList(response.data.filter((item: { IsCompletion: string; })=>item.IsCompletion=="TRUE"))

                const currentMonth = new Date().getMonth();

                const reorderedMonths = months
                .slice(currentMonth + 1) // Get the months from the next month onward
                .concat(months.slice(0, currentMonth + 1));
                let monthlySummary = reorderedMonths.map((month, index) => ({
                    name: month,
                    จำนวนโครงการที่ยื่นในระบบ: 0,
                    จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ:0,
                    โครงการที่ถูกยื่นขอปิดโครงการ:0,
                    จำนวนโครงการที่ปิดไปแล้ว:0,
                    จำนวนงบประมาณที่ถูกยื่นขอ:0,
                    จำนวนงบประมาณที่ถูกใช้ไป:0,
                  }));

                  for(let i = 0;i<12;i++){
                    const index = reorderedMonths.indexOf(months[i])
                    const Projects = filterByMonth(response.data, i);     
                    console.log(Projects) 
                    const Projectsent = Projects.filter((item: { IsCompletion: string; })=>item.IsCompletion=="FALSE")
                    monthlySummary[index].จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ = Projectsent.length
                    const CompletionProjectsent = Projects.filter((item: { IsCompletion: string; })=>item.IsCompletion=='TRUE')
                    monthlySummary[index].โครงการที่ถูกยื่นขอปิดโครงการ = CompletionProjectsent.length
                    monthlySummary[index].จำนวนโครงการที่ปิดไปแล้ว = Projects.filter((item: { IsCompletion: string; ReportStatus: string; }) => {
                      return item.IsCompletion === 'TRUE' &&
                              item.ReportStatus === 'อนุมัติ';
                  }).length;
                }
                getCompletionReport(monthlySummary);
            }}
        )
    }

    const getGraph = async () => {

        const response = await axios.get(
            `${process.env.REACT_APP_BASE}/GetProgressList`
        )
    
        if (response.status !== 200) return;
    
        const data = response.data
    
        let monthlySummary = months.map((month) => ({
            name: month,
            จำนวนโครงการที่ยื่นในระบบ: 0,
            จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ: 0,
            โครงการที่ถูกยื่นขอปิดโครงการ: 0,
            จำนวนโครงการที่ปิดไปแล้ว: 0,
            จำนวนงบประมาณที่ถูกยื่นขอ: 0,
            จำนวนงบประมาณที่ถูกใช้ไป: 0,
        }))
    
        for (let i = 0; i < 12; i++) {
    
            const index = months.indexOf(months[i])
    
            const Projects = filterByMonth(data, i)
    
            // รายงานความก้าวหน้า
            const Projectsent = Projects.filter(
                (item: any) => item.IsCompletion == "FALSE"
            )
    
            monthlySummary[index]
                .จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ =
                Projectsent.length
    
            // ขอปิดโครงการ
            const CompletionProjectsent = Projects.filter(
                (item: any) => item.IsCompletion == 'TRUE'
            )
    
            monthlySummary[index]
                .โครงการที่ถูกยื่นขอปิดโครงการ =
                CompletionProjectsent.length
    
            // ปิดโครงการแล้ว
            monthlySummary[index]
                .จำนวนโครงการที่ปิดไปแล้ว =
                Projects.filter((item: any) => {
                    return (
                        item.IsCompletion === 'TRUE' &&
                        item.ReportStatus === 'อนุมัติ'
                    )
                }).length
    
            // งบประมาณที่ยื่นขอ
            monthlySummary[index]
                .จำนวนงบประมาณที่ถูกยื่นขอ =
                Projects.reduce(
                    (sum: number, item: any) =>
                        sum + (item.BUDGET || 0),
                    0
                )
    
            // งบประมาณที่ใช้ไป
            monthlySummary[index]
                .จำนวนงบประมาณที่ถูกใช้ไป =
                Projects.reduce(
                    (sum: number, item: any) =>
                        sum + (item.SPENT || 0),
                    0
                )
        }
    
        setSummarydata(monthlySummary)
    
        // ============================
        // Faculty Summary
        // ============================
    
        const res = await axios.get(
            `https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`
        )
    
        if (res.status === 200) {
    
            setFac(
                res.data.filter(
                    (fac: any) => fac.Fac_ID !== "70"
                )
            )
    
            const uniqueFacIDs = Array.from(
                new Set(
                    data.map((item: any) => item.Fac_ID)
                )
            )
    
            const FacSum = uniqueFacIDs.map((Fac_ID) => {
    
                const faculty = res.data.filter(
                    (item: any) => item.Fac_ID == Fac_ID
                )
    
                return {
    
                    name:
                        faculty[0]?.Fac_NameTH || Fac_ID,
    
                    จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ:
                        data.filter(
                            (item: any) =>
                                item.Fac_ID == Fac_ID &&
                                item.IsCompletion == 'FALSE'
                        ).length,
    
                    จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ:
                        Array.from(
                            new Set(
                                data
                                    .filter(
                                        (item: any) =>
                                            item.Fac_ID == Fac_ID &&
                                            item.IsCompletion == 'FALSE'
                                    )
                                    .map(
                                        (item: any) =>
                                            item.head_researcher
                                    )
                            )
                        ).length,
    
                    โครงการที่ถูกยื่นขอปิดโครงการ:
                        data.filter(
                            (item: any) =>
                                item.Fac_ID == Fac_ID &&
                                item.IsCompletion == 'TRUE'
                        ).length,
    
                    จำนวนโครงการที่ปิดไปแล้ว:
                        data.filter(
                            (item: any) =>
                                item.Fac_ID == Fac_ID &&
                                item.IsCompletion == 'TRUE' &&
                                item.ReportStatus == 'อนุมัติ'
                        ).length,
    
                    จำนวนงบประมาณที่ถูกยื่นขอ:
                        data
                            .filter(
                                (item: any) =>
                                    item.Fac_ID == Fac_ID
                            )
                            .reduce(
                                (sum: number, item: any) =>
                                    sum + (item.BUDGET || 0),
                                0
                            ),
    
                    จำนวนงบประมาณที่ถูกใช้ไป:
                        data
                            .filter(
                                (item: any) =>
                                    item.Fac_ID == Fac_ID
                            )
                            .reduce(
                                (sum: number, item: any) =>
                                    sum + (item.SPENT || 0),
                                0
                            ),
                }
            })
    
            setFacSummarydata(FacSum)
        }
    }

   

    const getCompletionReport = async(tmp:any) => {
        axios.get(`${process.env.REACT_APP_BASE}/GetCompletion`).then(async response=>{
          if(response.status==200){
            const currentMonth = new Date().getMonth();
  
            await axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then((res) => {
              if(res.status==200){
                setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
                const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));
  
                const FacSum = uniqueFacIDs.map((Fac_ID) => {
                  const faculty = res.data.filter((item:any) => item.Fac_ID==Fac_ID);
                  let x = response.data
                  return {
                    name: faculty[0]?.Fac_NameTH || Fac_ID, // Access the first element of the array
                    จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ: response.data.filter((item: any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE').length,
                    โครงการที่ถูกยื่นขอปิดโครงการ: x.filter((item: {
                      IsCompletion: string;
                      project_status: string; Fac_ID: unknown; 
                      })=>item.Fac_ID == Fac_ID &&item.IsCompletion=='TRUE').length,
                    จำนวนโครงการที่ปิดไปแล้ว: x.filter((item:any)=>item.Fac_ID == Fac_ID).reduce(
                      (sum: any, item: { AllSumHis: any; }) => sum + (item.AllSumHis || 0), 
                      0
                    ),
                    จำนวนงบประมาณที่ถูกยื่นขอ : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.BUDGET || 0), 0),
                    จำนวนงบประมาณที่ถูกใช้ไป : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.SPENT || 0), 0),
                  };
                });
  
                console.log(FacSum)
                setFacBudgetData(FacSum)
              }
            })
  
            
          }
        })
      }
  

    const SearchData = async()=>{
        const searchForm = SearchForm.getFieldsValue();
        const data = {
            project_name:searchForm.project_name,
            head_name_th:searchForm.head_name_th,
            SentOrder:searchForm.SentOrder,
            project_status:searchForm.project_status,
            SentDate:searchForm.SentDate,
            SentYear:searchForm.SentYear,
            YearType:searchForm.YearType
        }
        await axios.post(`${process.env.REACT_APP_BASE}/GetProgressList`,data).then(response=>{
            if(response.status==200){
                setProgresslist(response.data.filter((item: { IsCompletion: string; })=>item.IsCompletion=="FALSE"))
                setCompleteReportList(response.data.filter((item: { IsCompletion: string; })=>item.IsCompletion=="TRUE"))
                setShownCompleteReportList(response.data.filter((item: { IsCompletion: string; })=>item.IsCompletion=="TRUE"))

                notification.success({message:'ค้นหาข้อมูลเสร็จสิ้น'})
            }else{
                notification.error({message:'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งในภายหลัง'})
            }
        }) 
    }

    const querynewDataForGraph = async(QueryType:any,Year:any,facOrAll:any)=>{
        if(facOrAll=='all')
        {
            setYearType(QueryType)
            setYearQuery(Year)
    }
        else{
            setFacYearType(QueryType)
            setFacYearQuery(Year)
        }

        const data = {
            YearType:QueryType,
            Year:moment(Year)
        }
        axios.post(`${process.env.REACT_APP_BASE}/GraphQuery`,data).then(async response=>{
            if(response.status==200)
                if(YearType=='ปีปฏิทิน')
                {
                let monthlySummary= months.map((month, index) => ({
                    name: month,
                    จำนวนโครงการที่ยื่นในระบบ: 0,
                    จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ:0,
                    โครงการที่ถูกยื่นขอปิดโครงการ:0,
                    จำนวนโครงการที่ปิดไปแล้ว:0,
                    จำนวนงบประมาณที่ถูกยื่นขอ:0,
                    จำนวนงบประมาณที่ถูกใช้ไป:0,
                  }));

                  for(let i = 0;i<12;i++){
                    const index = months.indexOf(months[i])
                    const Projects = filterByMonth(response.data, i);     
                    console.log(Projects) 
                    const Projectsent = Projects.filter((item: { IsCompletion: string; })=>item.IsCompletion=="FALSE")
                    monthlySummary[index].จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ = Projectsent.length
                    const CompletionProjectsent = Projects.filter((item: { IsCompletion: string; })=>item.IsCompletion=='TRUE')
                    monthlySummary[index].โครงการที่ถูกยื่นขอปิดโครงการ = CompletionProjectsent.length
                    monthlySummary[index].จำนวนโครงการที่ปิดไปแล้ว = Projects.filter((item: { IsCompletion: string; ReportStatus: string; }) => {
                      return item.IsCompletion === 'TRUE' &&
                              item.ReportStatus === 'อนุมัติ';
                  }).length;
                }

                setSummarydata(monthlySummary)
                await axios.get(`https://i.vu.ac.th/digitalId/vuapiver1/vu/select_faculty.php`).then((res) => {
                    if(res.status==200){
                    setFac(res.data.filter((fac: any) => fac.Fac_ID !== "70"));
                  
                    // Extract unique Fac_IDs from the correct response data
                    const uniqueFacIDs = Array.from(new Set(response.data.map((item: { Fac_ID: any }) => item.Fac_ID)));
                    // Map uniqueFacIDs to create the summary
                    const FacSum = uniqueFacIDs.map((Fac_ID) => {
                      const faculty = res.data.filter((item:any) => item.Fac_ID==Fac_ID);
                      let x = response.data
                      return {
                        name: faculty[0]?.Fac_NameTH || Fac_ID, // Access the first element of the array
                        จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ: response.data.filter((item: any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE').length,
                        จำนวนนักวิจัยที่ยื่นรายงานความก้าวหน้าในระบบ: Array.from(
                          new Set(
                            response.data
                              .filter((item: any) => item.Fac_ID == Fac_ID&&item.IsCompletion=='FALSE')
                              .map((item: any) => item.head_researcher)
                          )
                        ).length,
                        โครงการที่ถูกยื่นขอปิดโครงการ: x.filter((item: {
                          IsCompletion: string;
                          project_status: string; Fac_ID: unknown; 
                          })=>item.Fac_ID == Fac_ID &&item.IsCompletion=='TRUE').length,
                        จำนวนโครงการที่ปิดไปแล้ว: x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE'&&item.ReportStatus=='อนุมัติ').length,
                        จำนวนงบประมาณที่ถูกยื่นขอ : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.BUDGET || 0), 0),
                        จำนวนงบประมาณที่ถูกใช้ไป : x.filter((item:any)=>item.Fac_ID == Fac_ID&&item.IsCompletion=='TRUE').reduce((sum: number, item: any) => sum + (item.SPENT || 0), 0),
                      };
                    });

                  console.log(FacSum)
                  setFacSummarydata(FacSum)
                  }
                  });
                }else if (YearType === 'ปีการศึกษา') {

                    const academicMonths = [
                        'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน',
                        'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
                        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม'
                      ];

                      const monthIndexMap: Record<string, number> = {
                        'มกราคม': 0,
                        'กุมภาพันธ์': 1,
                        'มีนาคม': 2,
                        'เมษายน': 3,
                        'พฤษภาคม': 4,
                        'มิถุนายน': 5,
                        'กรกฎาคม': 6,
                        'สิงหาคม': 7,
                        'กันยายน': 8,
                        'ตุลาคม': 9,
                        'พฤศจิกายน': 10,
                        'ธันวาคม': 11,
                      };

                    let monthlySummary = academicMonths.map(month => ({
                      name: month,
                      จำนวนโครงการที่ยื่นในระบบ: 0,
                      จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ: 0,
                      โครงการที่ถูกยื่นขอปิดโครงการ: 0,
                      จำนวนโครงการที่ปิดไปแล้ว: 0,
                      จำนวนงบประมาณที่ถูกยื่นขอ: 0,
                      จำนวนงบประมาณที่ถูกใช้ไป: 0,
                    }));
                  
                    academicMonths.forEach((month, idx) => {
                      const realMonthIndex = monthIndexMap[month]; 
                  
                      const Projects = filterByMonth(response.data, realMonthIndex);
                  
                      const Projectsent = Projects.filter(
                        (item: any) => item.IsCompletion === 'FALSE'
                      );
                  
                      monthlySummary[idx].จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ =
                        Projectsent.length;
                  
                      const CompletionProjectsent = Projects.filter(
                        (item: any) => item.IsCompletion === 'TRUE'
                      );
                  
                      monthlySummary[idx].โครงการที่ถูกยื่นขอปิดโครงการ =
                        CompletionProjectsent.length;
                  
                      monthlySummary[idx].จำนวนโครงการที่ปิดไปแล้ว =
                        Projects.filter(
                          (item: any) =>
                            item.IsCompletion === 'TRUE' &&
                            item.ReportStatus === 'อนุมัติ'
                        ).length;
                    });
                  
                    setSummarydata(monthlySummary);
                  }
                  
        })
        
    }

    useEffect(()=>{
        getData();
        getGraph();
    },[]);

    
    return (<>
        <h1 className="text-3xl font-semibold ">ข้อมูลรายงานความคืบหน้าและคำขอปิดโครงการ</h1>
        <br/>
        <hr/>
        <br/>
        <Flex justify='space-between'>
            <h1 className='font-semibold text-3xl'>กราฟสรุปรายงานความคืบหน้าและคำขอปิดโครงการ</h1>
            <div>
                <Select style={{width:'130px'}}
                value={YearType}
                onChange={(value)=>setYearType(value)}
                options={[
                    {label:'ปีการศึกษา',value:'ปีการศึกษา'},
                    {label:'ปีปฏิทิน',value:'ปีปฏิทิน'},
                ]}/>&nbsp;
                <DatePicker 
                    style={{width:'130px'}}
                    value={YearQuery}
                    onChange={(value)=>setYearQuery(value)}
                    placeholder='เลือกปี'
                    picker="year" />
                <Button onClick={()=>querynewDataForGraph(YearType,YearQuery,'All')}><SearchOutlined /></Button>
                <Button><UndoOutlined /></Button>

            </div>
        </Flex>
            <Flex justify='center'>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={summary_data}>
                    <XAxis dataKey="name" />
                        <YAxis allowDecimals={false}/>
                        <Tooltip />
                        <Legend />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line type="monotone" dataKey="จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ" stroke="#8884d8" />
                        <Line type="monotone" dataKey="โครงการที่ถูกยื่นขอปิดโครงการ" stroke="#82ca9d" />
                        <Line type="monotone" dataKey="จำนวนโครงการที่ปิดไปแล้ว" stroke="red" />
                    </LineChart>
                </ResponsiveContainer>
            </Flex>
        <Flex justify='space-between'>
            <h1 className='font-semibold text-3xl'>แดชบอร์ดรายงานความคืบหน้าแต่ละแผนก</h1>
            <div>
                <Select style={{width:'130px'}}
                onChange={(value)=>{
                    querynewDataForGraph(value,FacYearQuery,'fac')
                }}
                value={FacYearType}
                options={[
                    {label:'ปีการศึกษา',value:'ปีการศึกษา'},
                    {label:'ปีปฏิทิน',value:'ปีปฏิทิน'},
                ]}/>&nbsp;
                <DatePicker
                picker="year"
                value={FacYearQuery}
                onChange={(value) => querynewDataForGraph(FacYearType,value,'fac')}
                placeholder="เลือกปี"
                />&nbsp;
                <Button><UndoOutlined /></Button>
            </div>
        </Flex>

        <Flex justify='center'>
        <ResponsiveContainer width="100%" height={300}>
            <BarChart data={fac_summary_data}>
                <XAxis dataKey="name" />
                <YAxis allowDecimals={false}/>
                <Tooltip/>
                <Legend />
                <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                <Bar onClick={(item)=>console.log(item.payload)} dataKey="จำนวนรายงานความก้าวหน้าที่ถูกยื่นเข้ามาในระบบ" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
                <Bar dataKey="จำนวนโครงการที่ปิดไปแล้ว" fill="#82ca9d" activeBar={<Rectangle fill="orange" stroke="yellow" />} />
            </BarChart>
        </ResponsiveContainer>
        </Flex>
        <h1 className='font-semibold text-3xl'>ทุนที่ยื่นขอมาและใช้ไป</h1>
        <Flex justify='center'>
        <ResponsiveContainer width="100%" height={300}>
        <BarChart data={fac_budget_data}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip  content={<CustomTooltip />}/>
            <Legend />
            <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
            <Bar dataKey="จำนวนงบประมาณที่ถูกยื่นขอ" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
            <Bar dataKey="จำนวนงบประมาณที่ถูกใช้ไป" fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
            </BarChart>
        </ResponsiveContainer>
        </Flex>
        <h1 className='font-semibold text-3xl'>รายชื่อโครงการในระบบ</h1>
        <Card>
            <h3 className="text-xl font-semibold">ค้นหาข้อมูล</h3>
            <Form form={SearchForm}>
                <Row>
                    <Col span={11}>
                        <Form.Item name='project_name' label='ชื่อโครงการที่ต้องการค้นหา'>
                            <Input placeholder='ชื่อโครงการภาษาไทย'/>
                        </Form.Item>
                    </Col>
                    <Col span={2}/>
                    <Col span={11}>
                        <Form.Item name='project_name' label='ชื่อโครงการที่ต้องการค้นหา'>
                            <Input placeholder='ชื่อโครงการภาษาอังกฤษ'/>
                        </Form.Item>
                    </Col>
                    <Col span={11}>
                        <Form.Item name='head_name_th' label='ชื่อผู้ยื่น'>
                            <Input placeholder='กรอกชื่อจริงหรือนามสกุลของผู้ยื่น'/>
                        </Form.Item>
                    </Col>
                    <Col span={2}/>
                    <Col span={11}>
                        <Form.Item name='SentOrder' label='ครั้งความคืบหน้าที่ยื่น'>
                            <InputNumber min={1} width='20vw' placeholder='1, 2, 3'/>
                        </Form.Item>
                    </Col>
                    <Col span={11}>
                        <Form.Item name='project_status' label='สถานะ'>
                            <Select options={[
                                {label:'มีข้อแก้ไข',value:'มีข้อแก้ไข'},
                                {label:'ยื่นความคืบหน้าโครงการ',value:'ยื่นความคืบหน้าโครงการ'},
                                {label:'อนุมัติ',value:'อนุมัติ'},
                            ]}
                            placeholder='เลือกสถานะโครงการ'
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}/>
                    <Col span={11}>
                        <Form.Item name='SentDate' label='วันเวลาที่ยื่น'>
                            <DatePicker placeholder='เลือกวันที่ต้องการตรวจสอบ'/>
                        </Form.Item>
                    </Col>
                    <Col span={11}>
                        <Form.Item name='YearType' >
                            <Radio.Group>
                                <Radio value={'ปีการศึกษา'}>ปีการศึกษา</Radio>
                                <Radio value={'ปีปฏิทิน'}>ปีปฏิทิน</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                    <Col span={2}/>
                    <Col span={11}>
                        <Form.Item name='SentYear' >
                            <DatePicker placeholder='เลือกปี' picker="year"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Flex justify='flex-end'>
                    <Button type='primary' danger htmlType='reset' onClick={getData}>รีเซ็ตการค้นหา</Button>&nbsp;
                    <Button type='primary' htmlType='submit' onClick={SearchData}>ค้นหา</Button>
                </Flex>
            </Form>
        </Card>
        <Row>
            <Col span={12}>
                <Card style={{margin:10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '200px', 
                    backgroundColor:'#1A3D64',
                    color:'white'}}
                onClick={()=>setshowstatus('รายงานความก้าวหน้า')}    
                hoverable bordered={false}
                >
                    <p className='text-2xl font-semibold' style={{marginBottom:10}}>รายงานความก้าวหน้าโครงการ</p>
                    <p className='text-5xl font-semibold'>{ProgressReportList.filter(
                        (item) =>
                        item.IsCompletion === 'FALSE' 
                    ).length}</p>
                </Card>
            </Col>
            <Col span={12}>
                <Card style={{margin:10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    height: '200px', 
                    backgroundColor:'#6ab04c',
                    color:'white'}}
                    onClick={()=>setshowstatus('คำขอปิดโครงการ')}  
                hoverable bordered={false}  
                    >
                        <p className='text-2xl font-semibold' style={{marginBottom:10}}>คำขอปิดโครงการ</p>
                        <p className='text-5xl font-semibold'>{CompleteReportList.filter(
                        (item) =>
                        item.IsCompletion === 'TRUE' 
                    ).length}</p>
                </Card>
            </Col>
        </Row>
        {
            showstatus=='คำขอปิดโครงการ'&&
            <>
                <Row>
                    <Col span={12}>
                        <Card 
                            hoverable bordered={false}
                            onClick={()=>setShownCompleteReportList(CompleteReportList.filter((item)=>item.ReportStatus!='อนุมัติ'))}
                            style={{
                            margin:10,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            height: '200px', 
                            backgroundColor:'#f9ca24',
                            color:'white'}}>
                                <p className='text-2xl font-semibold' style={{marginBottom:10}}>โครงการที่ถูกยื่นขอปิด</p>
                                <p className='text-5xl font-semibold'>{CompleteReportList.filter(
                                (item) =>
                                item.IsCompletion === 'TRUE' 
                            ).length}</p>
                        </Card>
                    </Col>
                    <Col span={12}>
                    <Card 
                        hoverable bordered={false}
                        onClick={()=>setShownCompleteReportList(CompleteReportList.filter((item)=>item.ReportStatus=='อนุมัติ'))}
                        style={{
                        margin:10,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        height: '200px', 
                        backgroundColor:'#6ab04c',
                        color:'white'}}>
                            <p className='text-2xl font-semibold' style={{marginBottom:10}}>โครงการที่ปิดไปแล้ว</p>
                            <p className='text-5xl font-semibold'>{CompleteReportList.filter(
                            (item) =>
                            item.ReportStatus === 'อนุมัติ' 
                        ).length}</p>
                        </Card>
                    </Col>
                </Row>
            </>
        }
        {showstatus=='รายงานความก้าวหน้า'&&
            <h1 className="text-2xl font-semibold ">รายงานความก้าวหน้าที่ถูกยื่นในระบบ</h1>||
            <h1 className="text-2xl font-semibold ">รายการคำขอปิดโครงการที่ถูกยื่นในระบบ</h1>
        }
        <Table columns={[
            {
                title:'ชื่อโครงการ',
                dataIndex:'project_name_th',

            },{
                title:'ผู้ยื่นความก้าวหน้า',
                dataIndex:'head_name_th',
            },
            {
                title:'จำนวนทุนที่ยื่นขอ',
                dataIndex:'BUDGET',
                width:'7vw',
                render:(value:any)=> Number(value).toFixed(2)
            },
            {
                title:'จำนวนทุนที่ใช้ไป',
                dataIndex:'SPENT',
                width:'7vw',
                render:(value:any)=> Number(value).toFixed(2)
            },
            {
                title:'ครั้งที่ยื่นความก้าวหน้า',
                dataIndex:'SentOrder',
                width:'7vw'
            },{
                title:<>{showstatus=='รายงานความก้าวหน้า'&&<>สถานะรายงานความก้าวหน้า</>||<>สถานะการยื่นนปิดโครงการ</>}</>,
                dataIndex:'ReportStatus',
                render: (ReportStatus: string) => 
                    {
                        let color = 'purple'
                        if(showstatus=='คำขอปิดโครงการ'){if(sessionStorage.getItem("PositionName")=="เจ้าหน้าที่"){
                            switch (ReportStatus) {
                                case 'รอการพิจารณาจากเจ้าหน้าที่วิจัย':
                                    color = "blue";
                                    break;
                            
                                case 'รอการพิจารณาจากผู้อำนวยการสำนักวิจัย':
                                case 'รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                    color = "purple";
                                    break;
                            
                                case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                                case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                                case 'สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                    color = "yellow";
                                    break;
                            
                                case 'อนุมัติ':
                                case 'ผ่าน':
                                    color = "green";
                                    break;
                            }
                            
                        }else if(sessionStorage.getItem("PositionName")=="ผู้อำนวยการสำนักวิจัยและบริการวิชาการ"){
                            switch(ReportStatus){
                                case 'รอการพิจารณาจากผู้อำนวยการสำนักวิจัย' : 
                                    color = "blue";
                                    break;
                              
                                case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                                case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                                case 'สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                    color = "yellow";
                                    break;
                                case 'อนุมัติ':
                                case 'ผ่าน':
                                    color = "green";
                                    break;
                            }
                        }else if(sessionStorage.getItem("PositionName")=="รองอธิการบดีฝ่ายวิจัยและบริการวิชาการ"){
                            switch(ReportStatus){
                                case 'รอการพิจารณาจากรองอธิการบดีสำนักฝ่ายวิจัยฯ' : 
                                    color = "blue";
                                    break;
                              
                                case 'สั่งแก้ไขจากเจ้าหน้าที่สำนักวิจัย':
                                case 'สั่งแก้ไขจากผู้อำนวยการสำนักวิจัย':
                                case 'สั่งแก้ไขจากรองอธิการบดีสำนักฝ่ายวิจัยฯ':
                                    color = "yellow";
                                    break;
                                case 'อนุมัติ':
                                case 'ผ่าน':
                                    color = "green";
                                    break;
                            }
                        }}else {
                                if (ReportStatus === 'ยื่นความคืบหน้าโครงการ') {
                                    color = 'geekblue';
                                } else if (ReportStatus === 'มีข้อแก้ไข'
                                ) {
                                    color = 'yellow';
                                } else if (ReportStatus === 'ผ่าน'
                                ) {
                                    color = 'green';
                                }
                                    else  {
                                    color = 'geekblue';
                                } 
                            }
                        return <Tag color={color}>{ReportStatus}</Tag>;
                    }
                    
            },{
                title:<>{showstatus=='รายงานความก้าวหน้า'&&<p>วันเวลาที่ยื่นรายงานความก้าวหน้า</p>
                ||<p>วันเวลาที่ยื่นคำขอปิดโครงการ</p>}</>,
                sorter: (a, b) =>{
                    const timeA = a.SentBy ? moment(a.SentBy).unix() : 0;
                    const timeB = b.SentBy ? moment(b.SentBy).unix() : 0;
                    return timeA - timeB;
                },
                render: (_, record) => (
                    <>{moment(record.SentBy).format('DD/MM/YY hh:mm:ss')}</>
                  ),
            },{
                dataIndex:'action',
                render: (_, record) => (
                    <>
                    <Button
                        onClick={() => {
                        sessionStorage.setItem('head_user', record.head_researcher);
                        sessionStorage.setItem('project_id', record.budgetreq_id);
                        if(showstatus=='รายงานความก้าวหน้า'){
                            navigate(`/VRIIS/ProgressReportReview/${record.ProgressReportID}`);
                        }else if(showstatus=='คำขอปิดโครงการ'){
                            navigate(`/VRIIS/CompletionReportReview/${record.ProgressReportID}`)
                        }
                        }}
                    >
                        ดูข้อมูล</Button></>
                  ),
            }
        ]}
        dataSource={showstatus === 'รายงานความก้าวหน้า' ? ProgressReportList : ShownCompleteReportList}/>
    </>)
}